import React, {Component} from 'react';
import {connect} from 'react-redux';
import {injectIntl, defineMessages} from 'react-intl';
import './homes.svg';
import './reviews.svg';
import './houses.svg';
import {OverviewItem} from './OverviewItem';

export const messages = defineMessages({
    title: {id: 'module.destination.infographic.overview.heading'},
    housesHeading: {id: 'module.destination.infographic.overview.star.rating.heading'},
    housesText: {id: 'module.destination.infographic.overview.star.rating.subheading'},
    reviewsHeading: {id: 'module.destination.infographic.overview.reviews.count.heading'},
    reviewsText: {id: 'module.destination.infographic.overview.reviews.count.subheading'},
    homesHeading: {id: 'module.destination.infographic.overview.listing.count.heading'},
    homesText: {id: 'module.destination.infographic.overview.listing.count.subheading'}
});

const mapStateToProps = (state) => ({
    simpleDestinationName: state.destination.details.simpleName,
    inventoryCount: state.destination.inventoryCount,
    overview: state.destination.infographic.overview
});

export class OverviewComponent extends Component {
    render() {
        const {
            intl,
            simpleDestinationName,
            inventoryCount,
            overview: {
                avgRating,
                reviewСount
            }
        } = this.props;

        const formatMessage = (key) =>
            intl.formatMessage(key, {
                simpleDestinationName,
                averageReviewStarRating: intl.formatNumber(avgRating.toFixed(1)),
                listingCount: intl.formatNumber(inventoryCount),
                reviewCount: intl.formatNumber(reviewСount)
            });

        return (
            <div className="destination-infographic__overview">
                <h3 className="overview__heading">{formatMessage(messages.title)}</h3>
                <div className="overview__items">
                    {['houses', 'reviews', 'homes'].map((item, index) => {
                        const icon = item;
                        const heading = formatMessage(messages[`${item}Heading`]);
                        const text = formatMessage(messages[`${item}Text`]);
                        return <OverviewItem key={index} {...{icon, heading, text}} />;
                    })}
                </div>
            </div>
        );
    }
}

export const Overview = injectIntl(
    connect(mapStateToProps)(OverviewComponent)
);
export default Overview;
